import angular from 'angular';
import '@uirouter/angularjs';
import 'angular-cookies';
import 'angular-translate';
import 'angular-animate';
import 'angular-dropdowns';
import 'ns-popover';
import 'angular-dropdowns/dist/angular-dropdowns.css';
import 'v-accordion';
import 'v-accordion/dist/v-accordion.css';
import 'particles.js';
import ngRedux from 'ng-redux';
import createSagaMiddleware from 'redux-saga';
import ngReduxUiRouter from 'redux-ui-router';
import moment from 'moment';

import reducers from './reducers';

import httpInterceptor from './interceptors/httpInterceptor';
import './schema/user';

import translations from './i18n';
import './vendor/ng-notie';

import './assets/fonts/fonts.css';
import './assets/custom-accordion.css';
import './assets/custom-dropdown.css';
import './assets/custom-selectui.css';
import './vendor/select2/select2.css';
import './main.sass';
import './variables.sass';
import './assets/img/ok.svg';
import './assets/img/ok-2.svg';
import './assets/img/comment-ok.svg';
import './assets/img/comment-todo.svg';
import './assets/img/cross.svg';
import './assets/NANDO_Informativa_Privacy.pdf';
import './modules/home';
import './modules/login';
import './modules/header';
import './modules/accounts';
import './modules/activation';
import './modules/request';
import './modules/company';
import './modules/company/detail';
import './modules/company/search';
import './modules/company/detail/documents';
import './modules/company/detail/structure';
import './modules/company/detail/contracts';
import './modules/company/detail/businessInfo';
import './modules/company/detail/techDoc';
import './modules/company/detail/questionnaire';
import './modules/note';
import './modules/contract';
import './modules/select';
import './modules/semaphore';
import './modules/table';
import './modules/editableField';
import './modules/card';
import './modules/formErrorPresenter';
import './modules/tabGroup';
import './modules/newAgencyModal';
import './modules/confirmationModal';
import './modules/ordersWizard';
import './modules/orders';
import './modules/loading';
import './modules/resetPassword';
import './modules/changePassword';
import './modules/ordersList';
import './modules/modal';
import './modules/inlineEditInput';
import './modules/lightTable';
import './modules/tab';
import './modules/accordion';
import './modules/accordions';
import './modules/biCard';
import './modules/biCards';
import './modules/biField';
import './modules/tippy';
import './modules/sticky';
import './modules/tableClientHomepage';
import './services/activation.service';
import './services/auth.service';
import './services/users.service';
import './services/config.service';
import './services/accounts.service';
import './services/companies.service';
import './services/orders.service';
import './services/questionnaires.service';
import './services/businessInfo.service';
import './services/mapping.service';
import './services/enum.service';
import './services/locale.service';
import './services/priceEntries.service';
import './services/questionnaire.service';
import './services/upload.service';
import './actions';
import './sagas';
import { isTokenExpired, isTokenValid, getUserFromToken } from './utilities/jwt';
import getStoredLanguage from './utilities/language';

const routes = [
  '$urlRouterProvider',
  ($urlRouterProvider) => {
    $urlRouterProvider.otherwise('/home');
  },
];

let initialState = {};
const sagaMiddleware = createSagaMiddleware();
const token = localStorage.getItem('jwt_token');

/* eslint-disable no-underscore-dangle */
const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
/* eslint-enable */
const storeEnhancement = [];
if ((process.env.REDUX_DEVTOOLS_ENABLED === 'true') && devTools) storeEnhancement.push(devTools);

angular.module('tct',
  [
    ngRedux,
    ngReduxUiRouter,
    'ui.router',
    'ngCookies',
    'ngDropdowns',
    'pascalprecht.translate',
    'vAccordion',
    'ngAnimate',
    'ngNotie',
    'nsPopover',
    'tct.actions',
    'tct.activation',
    'tct.sagas',
    'tct.home',
    'tct.login',
    'tct.header',
    'tct.accounts',
    'tct.request',
    'tct.company',
    'tct.company.detail',
    'tct.company.detail.documents',
    'tct.company.detail.businessInfo',
    'tct.company.detail.structure',
    'tct.company.detail.contracts',
    'tct.company.detail.techdoc',
    'tct.company.detail.questionnaire',
    'tct.company.search',
    'tct.note',
    'tct.contract',
    'tct.resetPassword',
    'tct.changePassword',
    'tct.authService',
    'tct.usersService',
    'tct.configService',
    'tct.activationService',
    'tct.accountsService',
    'tct.companiesService',
    'tct.businessInfoService',
    'tct.enumService',
    'tct.localeService',
    'tct.mappingService',
    'tct.priceEntriesService',
    'tct.questionnaireService',
    'tct.uploadService',
    'tct.select',
    'tct.semaphore',
    'tct.table',
    'tct.modal',
    'tct.editableField',
    'tct.card',
    'tct.tabgroup',
    'tct.formErrorPresenter',
    'tct.newAgencyModal',
    'tct.confirmationModal',
    'tct.ordersWizard',
    'tct.orders',
    'tct.loading',
    'tct.ordersList',
    'tct.ordersService',
    'tct.questionnairesService',
    'tct.inlineEditInput',
    'tct.lightTable',
    'tct.tab',
    'tct.accordion',
    'tct.biCard',
    'tct.biCards',
    'tct.accordions',
    'tct.biField',
    'tct.tippy',
    'tct.sticky',
    'tct.tableClientHomepage',
  ])
  .config(routes)
  .factory('authorizeInterceptor', ['$state',
    '$cookies',
    '$ngRedux',
    'actionsFactory',
    'notie',
    httpInterceptor])
  .config(($provide, $httpProvider, $translateProvider) => {
    $httpProvider.interceptors.push('authorizeInterceptor');
    $httpProvider.defaults.useXDomain = true;
    $httpProvider.defaults.withCredentials = true;

    $translateProvider
      .useSanitizeValueStrategy('escape')
      .translations('en', translations.english)
      .translations('it', translations.italian)
      .translations('es', translations.spanish)
      .preferredLanguage(getStoredLanguage());
  })
  .config(($ngReduxProvider) => {
    if (token && isTokenValid(token) && !isTokenExpired(token)) {
      const user = getUserFromToken(token);
      initialState = Object.assign({}, initialState, {
        authentication: {
          isAuthenticated: true,
          user,
          token,
        },
      });
    }

    $ngReduxProvider.createStoreWith(
      reducers,
      ['ngUiRouterMiddleware', sagaMiddleware],
      storeEnhancement,
      initialState,
    );
  })
  .config(($stateProvider) => {
    $stateProvider.state('authenticated', {
      url: '/',
      abstract: true,
      resolve: {
        auth: ['actionsFactory',
          '$ngRedux',
          (actionsFactory, $ngRedux) => {
            const state = $ngRedux.getState();
            const authenticated = state.authentication && state.authentication.isAuthenticated;
            if (!authenticated) {
              $ngRedux.dispatch(actionsFactory.state('not-authenticated.login'));
            }
          }],
      },
    });

    $stateProvider.state('not-authenticated', {
      url: '/',
      abstract: true,
      resolve: {
        auth: ['actionsFactory',
          '$ngRedux',
          (actionsFactory, $ngRedux) => {
            const state = $ngRedux.getState();
            const authenticated = state.authentication && state.authentication.isAuthenticated;
            if (authenticated) {
              $ngRedux.dispatch(
                actionsFactory.state(state.navigation.home.state, state.navigation.home.params));
            }
          }],
      },
    });
  })
  .run(($ngRedux, $rootScope, $timeout, sagaFactory, actionsFactory, $templateCache) => {
    $ngRedux.subscribe(() => {
      $timeout(() => {
        $rootScope.$apply(() => {
        });
      }, 100);
    });
    sagaMiddleware.run(sagaFactory.rootSaga);
    if ($ngRedux.getState().authentication.isAuthenticated) {
      $ngRedux.dispatch(actionsFactory.skipLogin($ngRedux.getState().authentication.user));
    }
    $templateCache.put('ngDropdowns/templates/dropdownMenu.html', [
      '<ul class="dropdown">',
      '<li ng-repeat="item in dropdownMenu"',
      ' ng-if="!item.hasOwnProperty(\'visible\') ? true : item[\'visible\']"',
      ' class="dropdown-item"',
      ' dropdown-item-label="labelField"',
      ' dropdown-menu-item="item">',
      '</li>',
      '</ul>',
    ].join(''));

    $templateCache.put('ngDropdowns/templates/dropdownMenuItem.html', [
      '<li ng-class="{divider: dropdownMenuItem.divider, \'divider-label\': dropdownMenuItem.divider && dropdownMenuItem[dropdownItemLabel]}">',
      '<a href="" class="dropdown-item"',
      ' ng-if="!dropdownMenuItem.divider"',
      ' ng-href="{{ dropdownMenuItem.href }}"',
      ' ng-click="selectItem()">',
      '{{ dropdownMenuItem[dropdownItemLabel] | translate }}',
      '</a>',
      '<span ng-if="dropdownMenuItem.divider">',
      '{{ dropdownMenuItem[dropdownItemLabel] | translate }}',
      '</span>',
      '</li>',
    ].join(''));
  })
  .directive('customOnChange', () => (
    {
      restrict: 'A',
      scope: {
        customOnChange: '=',
        customOnChangeThis: '=',
      },
      link(scope, element) {
        element.on('change', scope.customOnChange.bind(scope.customOnChangeThis));
        element.on('$destroy', () => element.off());
      },
    }
  ))
  .directive('postRender', ['$timeout',
    ($timeout) => {
      const def = {
        restrict: 'A',
        scope: {
          postRender: '=',
        },
        link(scope) {
          $timeout(scope.postRender, 0);
        },
      };
      return def;
    }])
  .filter('customdate', () => input => moment(input)
    .toDate());
